module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/images/app-1cf981.png";